import { SudokuGameStateModel } from './sudoku-game-states.model';
import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './sudoku-game.actions';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';
// @dynamic
@State<SudokuGameStateModel>({
  name: 'sudokuGameStates',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class SudokuGameState extends PuzzleGameBaseState {
  @Action(actions.InitSudokuGame)
  InitSudokuGame(state: StateContext<SudokuGameStateModel>, { payload }: actions.InitSudokuGame) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistSudokuState)
  PersistSudokuState(state: StateContext<SudokuGameStateModel>, { payload }: actions.PersistSudokuState) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            userInput: payload.userInput,
            notesInput: payload.notesInput,
          }),
        }),
      })
    );
  }
}
